<template>
    <div>
        <DialogoPreAfi ref="refModDatos" titulo="Editar mi legajo" type="modificacion" />
        <DialogoTerminos ref="dialogoTerminos" :bloqueoCerrar="false" />
        <v-navigation-drawer v-if="$vuetify.breakpoint.mdAndUp" app width="280" permanent clipped hide-overlay
            color="white" :style="{ top: $vuetify.application.top + 'px', zIndex: 4 }">
            <DialogoBlockTramite ref="redDialogoBlock" type="constancia" />
            <DialogoFaltaFoto ref="dialogoFaltaFoto" type="foto" @irAEditar="desplegarMod"
                msg="Para generar la credencial y/o constancia recordá cargar tu foto de legajo" />
            <DialogoCredencial ref="dialCred" :titulo="titulo" :tipo="tipo">
            </DialogoCredencial>
            <div v-if="items.length == 0">
                <v-progress-linear indeterminate height="5" color="primary"></v-progress-linear>
                <div v-for="i in 7" :key="i">
                    <v-skeleton-loader type="list-item-avatar" class="mx-0 my-2"></v-skeleton-loader>
                </div>
            </div>
            <Menu :items="items" @comunicaDrawer="irAfuncion"></Menu>
            <template v-slot:append>
                <div>
                    <div class="text-center mb-2 mx-2">
                        <v-btn text @click="abrirDialogoTerminos" color="grey darken-3">
                            <v-icon class=" mr-1">mdi-eye-outline</v-icon>
                            V
                            <div class="font-weight-light text-lowercase ">
                                er términos y condiciones
                            </div>
                        </v-btn>
                    </div>
                    <div class="text-center mb-2">
                        <v-chip x-small label outlined color="grey">
                            v{{ version }}<span v-if="fechaFormateada" class="mx-1">·</span>{{ fechaFormateada }}
                        </v-chip>
                    </div>
                    <div class="text-center mb-2 mx-2">
                        <v-btn color="black" block dark class="pa-6 rounded-lg elevation-0" @click="closeSesion">
                            <v-icon class="mr-2">mdi-logout</v-icon>
                            <div class="font-weight-medium ">
                                cerrar sesion
                            </div>
                        </v-btn>
                    </div>
                </div>
            </template>
        </v-navigation-drawer>
    </div>
</template>

<script>
import DialogoCredencial from '@/components/dialogos/DialogoCredencial'
import DialogoFaltaFoto from '@/components/dialogos/DialogoFaltaFoto'
import DialogoBlockTramite from '@/components/dialogos/DialogoBlockTramite'
import DialogoPreAfi from '@/components/dialogos/DialogoPreAfi'
import DialogoTerminos from '@/components/dialogos/DialogoTerminos'
import Menu from '@/components/navigations/Menu.vue'
import { mapActions, mapGetters } from 'vuex'

export default {
    components: {
        DialogoCredencial,
        DialogoBlockTramite,
        DialogoPreAfi,
        DialogoTerminos,
        DialogoFaltaFoto,
        Menu,
    },

    data() {
        return {
            group: null,
            toggle: false,
            menu: null,
            titulo: '',
            tipo: '',
            version: process.env.VUE_APP_VERSION || 'dev',
            fechaVersion: process.env.VUE_APP_VERSION_FECHA || '',
        }
    },
    methods: {
        ...mapActions('auth', ['cerrarSesion']),
        ...mapActions('notificaciones', ['startLoading']),
        ...mapActions('opcionNivel', ['abrirDialogoOpcionNivel']),
        ...mapActions('dataUser', ['fotoCarnet']),


        abrirDrawer() {
            this.isActive = !this.isActive
        },
        closeSesion() {
            this.startLoading()
            this.cerrarSesion()
            // this.$router.push('/CerrarSesion').catch(() => { })
        },
        lanzarDialogo() {
            this.$refs.dialCred.abrirDialogo()
        },
        irAfuncion(value) {
            if (value.accion === 'dialogoOpcionNivel') {
                this.abrirDialogoOpcionNivel()
                return
            }
            switch (value.title.split(' ')[0]) {
                case 'Credencial':
                    this.tipo = "credencial"
                    this.titulo = "Credencial de Afiliado"
                    if (!this.fotoCarnet) {
                        this.$refs.dialogoFaltaFoto.abrirDialogo()
                    }
                    else this.$refs.dialCred.abrirDialogo()
                    break;
                case 'Constancia':
                    if (!this.fotoCarnet) {
                        this.$refs.dialogoFaltaFoto.abrirDialogo()
                        return
                    }
                    if (this.user.tienedeuda) {
                        this.$refs.redDialogoBlock.abrirDialogo()
                        return
                    }
                    this.tipo = "constancia"
                    this.titulo = "Constancia para convenios"
                    this.lanzarDialogo()
                    break;
                default:
                    this.tipo = ""
                    this.titulo = ""
                    break;
            }
        },
        handleClick(value) {
            switch (value.title.split(' ')[0]) {
                case 'Credencial':
                    this.tipo = "credencial"
                    this.titulo = "Credencial de Afiliado"
                    this.lanzarDialogo()
                    break;
                case 'Constancia':
                    this.tipo = "constancia"
                    this.titulo = "Constancia para convenios"
                    this.lanzarDialogo()
                    break;
                default:
                    this.tipo = ""
                    this.titulo = ""
                    break;
            }
        },
        abrirDialogoTerminos() {
            this.$refs.dialogoTerminos.abrirDialogo()
        },
        desplegarMod() {
            this.$refs.refModDatos.abrirDialogo()
        }
    },
    computed: {
        ...mapGetters('auth', ['isAuthenticated', 'emailAuth', 'user', 'pedirFoto', 'fotoCarnet', 'esModoGestion']),
        ...mapGetters('navigations', ['items']),
        ...mapGetters('dataUser', ['fotoCarnet']),
        // Convierte la fecha ISO del version.json (YYYY-MM-DD) a DD/MM/YYYY.
        // Si la fecha no tiene formato esperado, la devuelve tal cual.
        fechaFormateada() {
            if (!this.fechaVersion) return ''
            const partes = this.fechaVersion.split('-')
            if (partes.length === 3) return `${partes[2]}/${partes[1]}/${partes[0]}`
            return this.fechaVersion
        },
    },
    /*     watch: {
            user(newUser) {
                this.menu = newUser && newUser.esjubilado ? this.menuJubilado : this.menuActivo;
            }
        },
        mounted() {
            this.menu = this.user.esjubilado ? this.menuJubilado : this.menuActivo;
        }, */
    props: ['drawer']

}
</script>

<style scoped>
</style>